import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { utilAgeBracketFormDefault } from "@factory/form/form.default";
import { UtilAgeBracketFormRule, UtilAgeBracketFormSchema } from "@factory/form/form.rule";
import { useQyCreateUtilAgeBracket } from "@factory/query/util-age-bracket.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewUtilAgeBracket() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateUtilAgeBracket } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New UtilAgeBracket is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addUtilAgeBracket, isLoading: isCreating } =
    useQyCreateUtilAgeBracket(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<UtilAgeBracketFormSchema>({
    defaultValues: utilAgeBracketFormDefault,
    resolver: zodResolver(UtilAgeBracketFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: UtilAgeBracketFormSchema) => {
    const formData = mapCreateUtilAgeBracket(form);
    addUtilAgeBracket(formData);
  };
  const handleValidateError = (err: FieldErrors<UtilAgeBracketFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
